import { useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ActiveRoute } from '@/lib/helpers';
import MegaMenu from './MegaMenu';
import MegaMenu2 from './MegaMenu2';

interface NavBarProps {
  styles?: string;
  projectTitle?: string;
}

const routes: Record<string, string> = {
  webdienste: '/corporate-design/webdienste',
  toolsAndServices: '/corporate-design/tools-and-services',
  templates: '/corporate-design/templates',
  basiselemente: '/basic-elements',
  components: '/components',
};

const NavBar = ({ styles, projectTitle = 'Projecttitle' }: NavBarProps) => {
  const route = useRouter();
  const navBarId: string = 'navbarNavMain';

  const handleRouteChange = (url: string) => {
    const element = document.getElementById(`${navBarId}`);

    if (element.classList.contains('show')) {
      element.classList.remove('show');
    }
  };

  useEffect(() => {
    route.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      route.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [route.events]);

  return (
    <>
      <nav className={`navbar navbar-expand-lg ${styles}`} role="navigation">
        <Link href="/">
          <a
            className={`navbar-brand ${route.pathname == '/' ? 'active' : ''}`}
          >
            <img
              src={`${process.env.NEXT_PUBLIC_BASE_URL}/fachhochschule-nordwestschweiz-fhnw-logo.svg`}
              alt="FHNW - Fachhochschule Nordwestschweiz"
              height={40}
              width={173.594}
            />
            {projectTitle}
          </a>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${navBarId}`}
          aria-controls={`${navBarId}`}
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>Menü
        </button>
        <div className="collapse navbar-collapse" id={`${navBarId}`}>
          <div className="navbar-title d-sm-none">{projectTitle}</div>
          <ul className="d-lg-none navbar-nav mr-auto mt-2 mt-md-0">
            <li className="nav-item">
              <Link href={'/'}>
                <a
                  className={`nav-link ${
                    route.pathname === '/' ? 'active' : ''
                  }`}
                  aria-current="page"
                >
                  Home
                </a>
              </Link>
            </li>
            <li className="nav-item dropdown">
              <a
                className={`nav-link dropdown-toggle ${
                  route.pathname.includes('/corporate-design') ? 'active' : ''
                }`}
                href="#"
                id="navbarCorporate"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Corporate Design
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarCorporate">
                <li>
                  <Link href={'/corporate-design/webdienste'}>
                    <a
                      className={`dropdown-item ${
                        route.asPath === '/corporate-design/webdienste/'
                          ? 'active'
                          : ''
                      }`}
                      title="Webdienste"
                    >
                      Webdienste
                    </a>
                  </Link>
                </li>
                <li>
                  <Link href={'/corporate-design/tools-and-services'}>
                    <a
                      className={`dropdown-item ${
                        route.asPath === '/corporate-design/tools-and-services/'
                          ? 'active'
                          : ''
                      }`}
                      title="Tools und Services"
                    >
                      Tools & Services
                    </a>
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link href={'/corporate-design/templates'}>
                    <a
                      className={`dropdown-item ${ActiveRoute(
                        routes.templates
                      )}`}
                      title="Styleguide Templates"
                    >
                      Templates
                    </a>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown has-megamenu">
              <a
                className={`nav-link dropdown-toggle ${
                  route.pathname.includes(`${routes.basiselemente}`)
                    ? 'active'
                    : ''
                }`}
                href="#"
                data-bs-toggle="dropdown"
              >
                Basiselemente
              </a>
              <div className="dropdown-menu megamenu" role="menu">
                <MegaMenu title={`Basiselemente des Styleguides`} />
              </div>
            </li>
            <li className="nav-item dropdown has-megamenu">
              <a
                className={`nav-link dropdown-toggle ${
                  route.pathname.includes(`${routes.components}`)
                    ? 'active'
                    : ''
                }`}
                href="#"
                data-bs-toggle="dropdown"
              >
                Komponenten
              </a>
              <div className="dropdown-menu megamenu" role="menu">
                <MegaMenu2 />
              </div>
            </li>
            <li className="nav-item">
              <Link className="" href="/download">
                <a
                  className={`nav-link ${
                    route.pathname === '/download' ? 'active' : ''
                  }`}
                >
                  Download
                </a>
              </Link>
            </li>
          </ul>

          {/* STYLEGUIDE VERSION LINKS */}
          <ul className="navbar-nav ms-auto mt-2 mt-md-0">
            <li className="nav-item dropdown">
              <a
                className={`nav-link dropdown-toggle`}
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                v5.3.2
              </a>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="navbarDropdown"
              >
                <li>
                  <Link
                    href={'https://webteam.pages.fhnw.ch/fhnw-styleguide-v4/'}
                  >
                    <a
                      target="_blank"
                      className="dropdown-item"
                      title="Webdienste"
                    >
                      v4.5.2
                    </a>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
